import React from 'react'
import styled from 'styled-components'

import logoImage from '../images/American_Express.svg'
import logoLightBlueImage from '../images/American_Express_blue.svg'

const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  width: 386px;
  padding: 40px 0;

  @media (max-width: 860px) {
    padding: 0;
  }

  @media (max-width: 480px) {
    height: 13px;
    width: auto;
  }
`

const Logo = ({ lightBlue = false }) => (
  <Image
    src={lightBlue ? logoLightBlueImage : logoImage}
    height="24"
    alt="AMERICAN EXPRESS"
  />
)

export default Logo
